import React from 'react';
import { Modal, Button } from 'antd';
import styles from './DeleteOrEndRoomTenantModal.module.scss';

const DeleteOrEndRoomTenant = ({ visible, onCancel, onDelete, onEnd }) => {
  return (
    <Modal
      title="Удаление/завершения договора аренды"
      visible={visible}
      onCancel={onCancel}
      footer={null}
      width={400}
      centered
      destroyOnClose
    >
      <div className={styles.container}>
        <Button type="danger" onClick={onDelete}>
          Удалить
        </Button>
        <Button type="primary" onClick={onEnd}>
          Завершить договор аренды
        </Button>
      </div>
    </Modal>
  );
};

export default DeleteOrEndRoomTenant;
